import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { IGetCrmSync } from 'crono-fe-common/types/crmSync';

export default function useGetCrmSync() {
  const request: Request = {
    url: ENDPOINTS.integration.settings,
    config: {
      method: 'get',
    },
  };

  return useQuery<Response<IGetCrmSync>, CronoError>({
    queryKey: [ENDPOINTS.integration.settings],
    queryFn: () => client(request),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
